import React from 'react';
import SourceInspectionPage from './SourceInspectionPage';

export const SourceInspection = () => {
    //<ModuleBridge moduleId="source_inspection_module" />
    return <SourceInspectionPage />;
};
